import React, { Component } from "react";
import { connect } from "react-redux";
import { createMetaTag, storeMetaTag } from "../../../store/ducks/seo/actions";
import Auxiliary from "../../../hoc/Auxiliary/Auxiliary";
import StringInput from "../../../components/Input/StringInput/StringInput";
import Textarea from "../../../components/Input/Textarea/Textarea";
import Select from "../../../components/Input/Select/Select";
import Button from "../../../components/Button/Button";
import MultipleCheckbox from "../../../components/Input/Checkbox/MultipleCheckbox";
import { formValidation } from "../../../hoc/Shared/utility";
import Swal from "sweetalert2";
import { withNamespaces } from "react-i18next";
import ValidationError from "../../../components/ValidationError/ValidationError";
import Skeleton from "react-loading-skeleton";
import { default as ReactSelect } from "react-select";

let languageArray = [];

class MetaTagCreate extends Component {
    constructor() {
        super();
        this.state = {
            name: "",
            url: "",
            status: 1,
            languages: "",
            title: "",
            description: "",
            keywords: "",
            h1: "",
            robot: [
                { robotTagId: 1, name: "Follow", isChecked: false },
                { robotTagId: 2, name: "Index", isChecked: false },
                { robotTagId: 3, name: "No Follow", isChecked: false },
                { robotTagId: 4, name: "No Index", isChecked: false },
                { robotTagId: 5, name: "No Snippet", isChecked: false },
                { robotTagId: 6, name: "No Translate", isChecked: false },
                { robotTagId: 7, name: "No Image Index", isChecked: false },
            ],
            loading: true,
            error_message: [],
            touched: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleCheckChieldElement = this.handleCheckChieldElement.bind(this);
    }

    componentDidMount() {
        this.props.createMetaTag();
        formValidation("meta_tag_form");
    }

    shouldComponentUpdate(nextProps, nextState) {
        // console.log("[MetaTagCreate] shouldComponentUpdate()", "\nnextProps: ", nextProps, "\nnextState: ", nextState);
        if (nextProps.metaTagCreateData !== this.props.metaTagCreateData) {
            if (nextProps.metaTagCreateData.data.responseCode === 200) {
                let languageData = nextProps.metaTagCreateData.data.data.language;
                languageArray = [];
                Object.keys(languageData).map((item, i) => {
                    return languageArray.push({
                        label: languageData[item].title,
                        value: languageData[item].langId,
                    });
                });

                this.setState({
                    loading: false,
                });
            } else {
                return false;
            }
        }

        if (nextProps.storeMetaTagResult !== this.props.storeMetaTagResult) {
            if (nextProps.storeMetaTagResult.responseCode === 200) {
                this.setState({ touched: false });
                const { t } = this.props;
                Swal.fire({
                    title: t("global.record-saved"),
                    icon: nextProps.storeMetaTagResult.msgType,
                    confirmButtonText: t("global.ok"),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.props.refreshHandler();
                        this.props.changePageHandler("listing");
                    }
                });
            } else if (nextProps.storeMetaTagResult.responseCode === 422) {
                this.setState({
                    touched: true,
                    error_message: nextProps.storeMetaTagResult.message,
                });
                Swal.close();
            } else {
                return false;
            }
        }
        return true;
    }

    storeMetaTagHandler = (e) => {
        e.preventDefault();
        const { t } = this.props;
        Swal.fire({
            title: t("global.confirmation"),
            text: t("global.are-you-sure"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: t("global.save"),
            cancelButtonText: t("global.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                let robotData = this.state.robot.filter((item) => item.isChecked === true).map((item) => item.robotTagId);
                let storeMetaTagData = {};
                storeMetaTagData.name = this.state.name;
                storeMetaTagData.url = this.state.url;
                storeMetaTagData.status = this.state.status;
                storeMetaTagData.languages = this.state.languages.value;
                storeMetaTagData.title = this.state.title;
                storeMetaTagData.description = this.state.description;
                storeMetaTagData.keywords = this.state.keywords;
                storeMetaTagData.h1 = this.state.h1;
                storeMetaTagData.robot = robotData;
                // console.log("Form Submit:", storeMetaTagData);
                this.props.storeMetaTag(storeMetaTagData);
            }
        });
    };

    handleChange = (event) => {
        // console.log(event);
        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    handleStatusChange = (event) => {
        this.setState({
            status: Number(event.target.value),
        });
    };

    handleLanguageChange = (event) => {
        this.setState({
            languages: event,
        });
    };

    handleCheckChieldElement = (event) => {
        let robotTags = this.state.robot;
        if ([1, 3].includes(Number(event.target.value))) {
            if (Number(event.target.value) === 1) {
                robotTags[2].isChecked = false;
            }

            if (Number(event.target.value) === 3) {
                robotTags[0].isChecked = false;
            }
        }

        if ([2, 4].includes(Number(event.target.value))) {
            if (Number(event.target.value) === 2) {
                robotTags[3].isChecked = false;
            }

            if (Number(event.target.value) === 4) {
                robotTags[1].isChecked = false;
            }
        }

        robotTags.forEach((rt) => {
            if (Number(rt.robotTagId) === Number(event.target.value)) {
                rt.isChecked = event.target.checked;
            }
        });
        this.setState({ robot: robotTags });
    };

    render() {
        const { t } = this.props;
        let display = null;
        let status = [
            { label: t("global.active"), value: 1 },
            { label: t("global.inactive"), value: 0 },
        ];

        let robotTag = this.state.robot.map((val, idx) => (
            <label className="ckbox mg-l-20" key={idx}>
                <MultipleCheckbox id={val.robotTagId} value={val.robotTagId} label={val.name} isChecked={val.isChecked} handleCheckChieldElement={this.handleCheckChieldElement} />
            </label>
        ));

        if (!this.state.loading) {
            display = (
                <>
                    <div className="row row-sm">
                        <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                            <div className="card box-shadow-0">
                                <div className="card-header">
                                    <h4 className="card-title mb-1">{t("meta-tags.add-meta-tag")}</h4>
                                </div>

                                <div className="card-body pt-0">
                                    <form method="post" id="meta_tag_form" className="form-horizontal" onSubmit={this.storeMetaTagHandler} noValidate>
                                        <ValidationError formName="meta_tag_form" touched={this.state.touched} message={this.state.error_message} />
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="name">{t("meta-tags.name")}</label>
                                                    <StringInput
                                                        id="name"
                                                        name="name"
                                                        className="form-control"
                                                        placeholder={t("meta-tags.name")}
                                                        value={this.state.name}
                                                        onChange={this.handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="url">{t("meta-tags.url")}</label>
                                                    <StringInput
                                                        id="url"
                                                        name="url"
                                                        className="form-control"
                                                        placeholder={t("meta-tags.url")}
                                                        value={this.state.url}
                                                        onChange={this.handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="status">{t("global.status")}</label>
                                                    <Select id="status" name="status" options={status} onChange={this.handleStatusChange} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="name">{t("global.languages")}</label>
                                                    <ReactSelect
                                                        options={languageArray}
                                                        isSearchable={true}
                                                        name="language"
                                                        onChange={this.handleLanguageChange}
                                                        placeholder={t("global.select")}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="title">{t("meta-tags.title")}</label>
                                                    <Textarea
                                                        id="title"
                                                        name="title"
                                                        className="form-control"
                                                        placeholder={t("meta-tags.title")}
                                                        value={this.state.title}
                                                        onChange={this.handleChange}
                                                        rows={5}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="description">{t("meta-tags.description")}</label>
                                                    <Textarea
                                                        id="description"
                                                        name="description"
                                                        className="form-control"
                                                        placeholder={t("meta-tags.description")}
                                                        value={this.state.description}
                                                        onChange={this.handleChange}
                                                        rows={5}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="password">
                                                        {t("meta-tags.keywords")} <small>({t("meta-tags.seperate")})</small>
                                                    </label>
                                                    <Textarea
                                                        id="keywords"
                                                        name="keywords"
                                                        className="form-control"
                                                        placeholder={t("meta-tags.keywords")}
                                                        value={this.state.keywords}
                                                        onChange={this.handleChange}
                                                        rows={5}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="h1">{t("meta-tags.h1")}</label>
                                                    <Textarea
                                                        id="h1"
                                                        name="h1"
                                                        className="form-control"
                                                        placeholder={t("meta-tags.h1")}
                                                        value={this.state.h1}
                                                        onChange={this.handleChange}
                                                        rows={5}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="mg-l-20" htmlFor="robot">
                                                        {t("meta-tags.robot-tags")}
                                                    </label>
                                                    <div className="form-check form-check-inline">{robotTag}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group mb-0 mt-3 justify-content-end">
                                            <div>
                                                <Button typeButton="submit" classValue="btn btn-blue" idValue="submit" buttonName={t("global.save")} />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            );
        } else {
            display = (
                <div className="row row-sm">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div className="card box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("meta-tags.add-meta-tag")}</h4>
                            </div>
                            <div className="card-body pt-0">
                                <Skeleton count={4} />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <Auxiliary>
                <div className="breadcrumb-header justify-content-between">
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto text-muted mt-1 tx-13 ml-2 mb-0">{t("seo.seo")}</h4>
                        </div>
                    </div>
                    <div className="d-flex my-xl-auto right-content">
                        <div className="mb-3 mb-xl-0">
                            <div className="btn-group">
                                <div className="pr-1 mb-3 mb-xl-0">
                                    <Button
                                        typeButton="button"
                                        classValue="btn btn-secondary ml-1"
                                        idValue="back"
                                        buttonName={t("global.back-to-list")}
                                        clicked={() => this.props.changePageHandler("listing")}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {display}
            </Auxiliary>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        metaTagCreateData: state.seo.meta_tag_create_data,
        storeMetaTagResult: state.seo.meta_tag_store_result,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createMetaTag: () => dispatch(createMetaTag()),
        storeMetaTag: (storeMetaTagData) => dispatch(storeMetaTag(storeMetaTagData)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(MetaTagCreate));
